import React, { useState } from 'react';

const Gallery = ({ images, hideControls = false }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="relative flex flex-col items-center justify-center">
      
      {/* Image Container */}
      <div className="relative w-full max-w-[120%] lg:max-w-[80%] aspect-w-16 aspect-h-9 bg-gray-100 rounded-lg shadow-md overflow-hidden flex items-center justify-center">
        
        <img
          src={images[currentImageIndex].src}
          alt={images[currentImageIndex].alt}
          className="w-full h-full object-contain rounded-lg"
        />

        {/* Conditionally Render Controls */}
        {!hideControls && (
          <>
            {/* Previous Button */}
            <button
              className="absolute left-11 -ml-10 top-1/2 transform -translate-y-1/2 bg-white text-2xl font-bold text-black-600 hover:text-gray-500 px-2 py-1 rounded-full shadow-lg opacity-80 hover:opacity-100"
              onClick={prevImage}
              aria-label="Go back to the previous image"
            >
              &lt;
            </button>

            {/* Next Button */}
            <button
              className="absolute right-11 -mr-10 top-1/2 transform -translate-y-1/2 bg-white text-2xl font-bold text-black-600 hover:text-gray-500 px-2 py-1 rounded-full shadow-lg opacity-80 hover:opacity-100"
              onClick={nextImage}
              aria-label="Go to the next image"
            >
              &gt;
            </button>
          </>
        )}
      </div>

      {/* Image Description */}
      <p className="text-center mt-4 text-lg text-gray-700 px-4">
        {images[currentImageIndex].description}
      </p>
    </div>
  );
};

export default Gallery;